import React, { Fragment } from "react";
import { Query } from "@apollo/client/react/components";

import CasesNav from "../../components/Cases/CasesNav/CasesSubNav";
import CasesTabs from "../../components/Cases/CasesTabs";
import CasesTable from "../../components/Cases/CasesTable";
import { caseTypesLookup } from "../../components/Cases/config";
import { CasesProvider } from "../../components/Cases/CasesContext";

import FullScreenSpinner from "../../global/components/FullScreenSpinner";
import renderStatusModal from "../../components/Forms/renderStatusModal";
import { GET_PAGINATED_COUNT } from "./queries";

let caseCountsErrorNotified = false;

const renderTable = (navCounts, groupRole, groupMembers, refetchTabsTable) => {
  return (
    <CasesTable
      navCounts={navCounts}
      groupRole={groupRole}
      groupMembers={groupMembers}
      refetchTabsTable={refetchTabsTable}
    />
  );
};

const CasesPage = ({ user_id, groupRole, group_id, groupMembers }) => {
  return (
    <Query query={GET_PAGINATED_COUNT}>
      {({ loading, error, data, refetch }) => {
        const refetchTabsTable = refetch;
        if (loading) return <FullScreenSpinner />;
        if (error) {
          if (!caseCountsErrorNotified) {
            renderStatusModal(
              false,
              "Case counts could not be retrieved. Please refresh or try again later.",
              7000
            );
            caseCountsErrorNotified = true;
          }

          return `Error! ${error.message}`;
        }

        if (data && data.getPaginatedCount) {
          caseCountsErrorNotified = false;
          const navCounts = data.getPaginatedCount;

          let sorted = Object.keys(navCounts)
            .sort(function (a, b) {
              return navCounts[b].Total - navCounts[a].Total;
            })
            .map((item) => {
              return {
                name: `${item.replace("Form", "")}`,
                data: navCounts[item],
              };
            })
            .filter((item) => item.name !== "__typename");
          const top = caseTypesLookup[sorted[0].name];

          return (
            <Fragment>
              <CasesProvider top={top}>
                <CasesNav navCounts={navCounts} sortedCounts={sorted} />
                <div
                  className="content-container"
                  style={{ paddingTop: "10px" }}
                >
                  <CasesTabs navCounts={navCounts} />
                  {renderTable(
                    navCounts,
                    groupRole,
                    groupMembers,
                    refetchTabsTable
                  )}
                </div>
              </CasesProvider>
            </Fragment>
          );
        } else {
          return <>Something went terribly wrong!</>;
        }
      }}
    </Query>
  );
};

export default CasesPage;
